import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEraser, faCopy } from '@fortawesome/free-solid-svg-icons';

const CaseConverter = () => {
  const [originalInput, setOriginalinput] = useState('Lorem Ipsum is simply dummy text of the printing and typesetting industry');

  const handleInputText = (event) => {
    setOriginalinput(event.target.value);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(originalInput);
  }

  const handleCaseConverter = (type) => {
    console.log(type)
    let newValue = originalInput;
    switch (type) {
      case 'Sentence Case':
        newValue = toSentenceCase(newValue)
        break;
      case 'UPPER CASE':
        newValue = newValue.toUpperCase();
        break;
      case 'lower case':
        newValue = newValue.toLowerCase();
        break;
      case 'Title Case':
        newValue = toTitleCase(newValue)
        break;
      case 'MiXeD CaSe':
        newValue =  toMixedCase(newValue)
        break;
      case 'iNvErSe cAsE':
        newValue = toInverseCase(newValue);
        break;
      default:
        break;
    }
    if (originalInput === newValue) {
      return
    }
    setOriginalinput(newValue);
  }

  const toInverseCase = (str) => {
    return str
      .split('') // Split the string into an array of characters
      .map(char => 
        char === char.toUpperCase() 
          ? char.toLowerCase() 
          : char.toUpperCase() // Invert the case of each character
      )
      .join(''); // Join the array of characters back into a single string
  }

  const toMixedCase = (str) => {
    return str
      .split('') // Split the string into an array of characters
      .map((char, index) => 
        index % 2 === 0 ? char.toLowerCase() : char.toUpperCase() // Alternate between lowercase and uppercase
      )
      .join(''); // Join the array of characters back into a single string
  }

  const toSentenceCase = (str) => {
    str = str.trim();
    if (str.length === 0) {
      return "";
    }
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
  
  const toTitleCase = (str) => {
    return str
      .toLowerCase() // Convert the entire string to lowercase first
      .split(' ')    // Split the string into an array of words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(' ');    // Join the array of words back into a single string
  }

  const resetAll = () => {
    setOriginalinput('');
  }

  // useEffect(() => {
  //   // Check if the elementRef has been assigned to a DOM element
  // }, []);

  return (
    <div class="grid grid-cols-1 xl:grid-cols-1 xl:gap-4">
      <div className="col-span-2">
        <div  className="p-4 mb-4 space-y-6 bg-white border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 font-medium text-md border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>Your input</h3>
          </div>
          <div className="px-4 py-2 rounded">
            <textarea
              id="inputText"
              rows={15}
              className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Text Goes Here"
              value={originalInput}
              onChange={handleInputText}
            />
          </div>
          <div className="px-4 py-2">
            <button
              onClick={() => handleCaseConverter('Sentence Case')}
              type="button"
              className="text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"
            >
              &nbsp; Sentence Case
            </button>
            <button
              onClick={() => handleCaseConverter('UPPER CASE')}
              type="button"
              className="text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"
            >
              &nbsp; UPPER CASE
            </button>
            <button
              onClick={() => handleCaseConverter('lower case')}
              type="button"
              className="text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"

            >
              &nbsp; lower case
            </button>
            <button
              onClick={() => handleCaseConverter('Title Case')}
              type="button"
              className="text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"

            >
              &nbsp; Title Case
            </button>
            <button
              onClick={() => handleCaseConverter('MiXeD CaSe')}
              type="button"
              className="text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"

            >
              &nbsp; MiXeD CaSe
            </button>
            <button
              nClick={() => handleCaseConverter('iNvErSe cAsE')}
              type="button"
              className="text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"

            >
              &nbsp; iNvErSe cAsE
            </button>
            <button
              onClick={resetAll}
              type="button"
              className="text-white bg-gray-400 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faEraser}/>
              &nbsp; Reset
            </button>
            <button
              type="button"
              onClick={handleCopy}
              className="text-white bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faCopy}/>
              &nbsp; Copy
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CaseConverter;
